prismanoteApp.directive('countryCode', function () {
  return {
    scope: {
      required: '=ngRequired',
      model: '=ngModel'
    },
    templateUrl: '../views/directives/country-code.html'
  }
})
